import type { JSX } from 'react';

import { Icon } from '~/components';
import { cn } from '~/lib/cn';

export interface MenuItemProps {
  className?: string;
  iconClassName?: string;
  title: string;
  disabled?: boolean;
  icon: string;
  iconOverlay?: () => JSX.Element;
  onClick: () => void;
  counter?: number;
  counterAsBadge?: boolean;
  testId?: string;
}

export function MenuItem(props: MenuItemProps) {
  return (
    <button
      data-testid={props.testId}
      className={cn(
        'group relative cursor-pointer rounded-xs border px-sm py-xs text-body-sm duration-300 ease-out bg-emphasis-default border-emphasis-subtle text-white hover:bg-emphasis-strong hover:outline-emphasis-stronger',
        props.disabled &&
          'pointer-events-none cursor-not-allowed opacity-stronger',
        props.className,
      )}
      onClick={props.onClick}
    >
      <Icon
        className={cn('mr-sm group-hover:text-white', props.iconClassName)}
        size="sm"
        type={props.icon}
      />
      {props.iconOverlay ? (
        <div className="absolute left-md top-sm">{props.iconOverlay()}</div>
      ) : null}
      {props.title}
      {!!props.counter && (
        <div
          data-testid="filter-button-badge"
          className={cn({
            'absolute -right-1/4 -top-1/4 grid h-lg min-w-lg items-center rounded-full border p-xs text-caption-md leading-none bg-primary-default border-emphasis-subtle':
              props.counterAsBadge,
            'ml-xs inline-block': !props.counterAsBadge,
          })}
        >
          {props.counterAsBadge ? props.counter : <>({props.counter})</>}
        </div>
      )}
    </button>
  );
}

MenuItem.displayName = 'MenuItem';
